import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Main from './Components/Home/Main'
import Login from './Components/Account/Login'
import Signup from './Components/Account/Signup'
import Contact from './Components/Pages/Contact'
import Propitorship from './Components/Pages/NewBussiness/Propitorship'
import ScrollToTopButton from './Components/Pages/ScrollToTop'
import Review from './Components/Pages/Review'
import Rewards from './Components/Pages/Rewards'
import About from './Components/Screens/About'
import IncomeTax from './Components/Pages/IncomeTax/IncomeTax'
import Gst from './Components/Pages/GST/Gst'
import Compliance from './Components/Pages/Compliance/Compliance'
import Loan from './Components/Pages/Loan/Loan'
import Investment from './Components/Pages/Investment/Investment'
function App() {
  return (
    <>
     
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/about" element={<About/>}/>
          <Route path="/login" element={<Login/>}/>
          <Route path="/Signup" element={<Signup/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/service/:slug" element={<Propitorship />} />
          <Route path="/incometax/:id" element={<IncomeTax/>}/>
          <Route path="/compliance/:id" element={<Compliance/>}/>
          <Route path="/gst/:id" element={<Gst/>}/>
          <Route path="/loan/:id" element={<Loan/>}/>
          <Route path="/investment/:id" element={<Investment/>}/>
          <Route path="/review" element={<Review/>}/>
          <Route path="/reward" element={<Rewards/>}/>
        </Routes>
        <ScrollToTopButton/>
    
      
    </>
  )
}

export default App





